import { createRouter, createWebHistory } from 'vue-router'
import Etapas from '@/views/Etapas.vue'
import DetalheAvaria from '@/common/avaria/components/DetalheAvaria.vue'
import DetalheFoto from '@/common/foto/components/DetalheFoto.vue'
import TirarFoto from '@/common/foto/components/TirarFoto.vue'
// import NotFound from '@/views/NotFound.vue'
import Resumo from '@/views/Resumo.vue'
import Middleware from '@/router/Middleware'
import DetalheAssinatura from '@/common/assinatura/components/DetalheAssinatura.vue'
import Modulos from '@/views/Modulos.vue'

const routes = [
  {
    path: '/:identificador',
    meta: { middleware: Middleware.obterParametrosRotaChecklist() },
  },
  {
    path: '/:identificador/:localRealizacao/:modulo/etapa/:etapa',
    name: 'Etapas',
    component: Etapas,
  },
  {
    path: '/:identificador/:localRealizacao/:modulo/resumo',
    name: 'Resumo',
    component: Resumo,
  },
  {
    path: '/:identificador/modulos',
    name: 'Modulos',
    component: Modulos,
  },
  {
    path: '/:identificador/:localRealizacao/:modulo/assinatura/:signatario',
    name: 'DetalheAssinatura',
    component: DetalheAssinatura
  },
  {
    path: '/:identificador/:localRealizacao/:modulo/etapa/:etapa/:idComponente/detalhe-avaria',
    name: 'DetalheAvaria',
    component: DetalheAvaria
  },
  {
    path: '/:identificador/:localRealizacao/:modulo/etapa/:etapa/:idComponente/edicao-imagem',
    name: 'DetalheFoto',
    component: DetalheFoto
  },
  {
    path: '/:identificador/:localRealizacao/:modulo/etapa/:etapa/:idComponente/tirar-foto',
    name: 'TirarFoto',
    component: TirarFoto
  },
  /* {
    path:  "/:pathMatch(.*)*",
    name: 'NotFound',
    component: NotFound
  } */
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
